import { render } from "./black_overlay.vue?vue&type=template&id=e1785f1c&scoped=true"
import script from "./black_overlay.vue?vue&type=script&lang=js"
export * from "./black_overlay.vue?vue&type=script&lang=js"

import "./black_overlay.vue?vue&type=style&index=0&id=e1785f1c&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1785f1c"]])

export default __exports__